import { Paper, Skeleton } from "@mui/material";

function DetailsSkeleton({count=8,variant="circular"}:{count?:number,variant?:"circular" | "rectangular" | "rounded"}) {
  return (
    <Paper>
      <div className="grid grid-cols-12 ">
        <div className="col-span-9 grid grid-cols-4 gap-2 p-2">
           {
             Array(count).fill(null).map((_,index:number)=><Skeleton key={`detailsSkeleton${index}`} variant="text" sx={{ height:25 }} />)
           } 
        </div>
        <div className="col-span-3 flex justify-end items-center py-2 pe-3">
            <Skeleton variant={variant} sx={{height:85,width:85}} />
        </div>
      </div>
    </Paper>
  );
}

export default DetailsSkeleton;
